import React from 'react';
import { painPoints } from '../data/painPoints';
export function PainSection() {
  return <section className="bg-navy py-5 sm:py-7" data-id="element-142" data-mp="38yggibtmasnx">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-143" data-mp="38x5cqc069kwt">
        <h2 className="text-center text-3xl leading-none text-white sm:text-5xl" data-id="element-144" data-mp="2uyoxfwo8um32">
          DOES THIS SOUND <span className="text-gold" data-id="element-145" data-mp="2yz7m5huubc11">FAMILIAR?</span>
        </h2>
        <p className="mx-auto mt-2 max-w-3xl text-center text-sm leading-snug text-white/85 sm:text-base" data-id="element-146" data-mp="2z1lkbzkth4ct">
          You're inspecting weld joints, identifying discontinuities, measuring weld profiles,
          interpreting NDT findings, and reviewing quality requirements—but technical manuals are
          packed with information that's difficult to visualize, compare, and apply during
          inspections.
        </p>

        <div className="mt-3 grid gap-2 md:grid-cols-2 md:gap-2.5" data-id="element-147" data-mp="228yf1bfkwy15">
          {painPoints.map(point => <article key={point.title} className="rounded-xl border-l-4 border-tech bg-navy-deep p-3 sm:p-4" data-id="element-148" data-mp="278uk7e00ivia">
              <h3 className="text-base leading-tight text-white sm:text-lg" data-id="element-149" data-mp="3rp3smtb9tvni">{point.title}</h3>
              <p className="mt-1 text-sm leading-snug text-white/80" data-id="element-150" data-mp="3nni9wrc22n5e">{point.body}</p>
            </article>)}
        </div>
      </div>
    </section>;
}